import React from 'react'
import { FormattedMessage } from 'react-intl'
import { REFINANCE } from 'src/constants/messages'
import { Format, If, InlineTextLock, Lock, Text } from 'src/Components'
import { BulletedList } from 'src/Components/shared/List'
import { IconTimesCircle, IconCheckCircle } from 'src/Components/shared/Icon'
import Rate from 'src/Components/shared/Rate'
import APR from 'src/Components/shared/APR'

import styles from './RefiPoint.module.scss'

const absRound = v => Math.abs(Math.round(v))

const RefiPoint = ({
  apr,
  intl,
  rate,
  savingsTotal,
  paymentSavings,
  term,
  years,
  withCurrentHomeData,
  locked
}) => (
  <div className={styles.container}>
    <div className={styles.rateContainer}>
      <Text element='h3' size='l' weight='light'>
        <FormattedMessage
          id='Homeowner.interest.refiTerm'
          defaultMessage='{years} Year'
          values={{ years }}
        />
      </Text>
      <Text
        color={savingsTotal > 0 ? 'green' : 'red'}
        size='xxl'
        weight='light'
        className={styles.total}
        element='div'
      >
        <Lock enabled={locked}>
          <Format.Currency value={Math.round(savingsTotal)} />
        </Lock>
      </Text>

      <Text color='quiet' size='xs' element='div'>
        <BulletedList.Inline compact>
          <Rate value={rate} />
          <APR value={apr} />
        </BulletedList.Inline>
      </Text>
    </div>
    <ul className={styles.list}>
      <li className={styles.listItem}>
        <If condition={savingsTotal > 0}>
          <Text color='green' element='span' className={styles.iconCol}>
            <IconCheckCircle />
          </Text>
        </If>
        <If condition={savingsTotal <= 0}>
          <Text color='red' element='span' className={styles.iconCol}>
            <IconTimesCircle />
          </Text>
        </If>{' '}
        <span className={styles.textCol}>
          <FormattedMessage
            id='Homeowner.interest.refinance.totalSavings'
            defaultMessage='Long term {savingsOrLossDescriptor}'
            values={{
              savingsOrLossDescriptor: intl.formatMessage(
                REFINANCE[savingsTotal > 0 ? 'savings' : 'loss']
              )
            }}
          />
        </span>
      </li>
      <li className={styles.listItem}>
        <If condition={paymentSavings > 0}>
          <Text color='green' element='span' className={styles.iconCol}>
            <IconCheckCircle />
          </Text>
        </If>
        <If condition={paymentSavings <= 0}>
          <Text color='red' element='span' className={styles.iconCol}>
            <IconTimesCircle />
          </Text>
        </If>{' '}
        <span className={styles.textCol}>
          <FormattedMessage
            id='Homeowner.interest.refinance.paymentSavings'
            defaultMessage='Payment goes {upOrDownDescriptor} by {amount}'
            values={{
              upOrDownDescriptor: intl.formatMessage(
                REFINANCE[
                  paymentSavings < 0 ? 'paymentIncrease' : 'paymentDecrease'
                ]
              ),
              amount: (
                <Text element='span' nowrap color='quiet'>
                  <FormattedMessage
                    id='Currency.per.month'
                    defaultMessage='{amount}/month'
                    values={{
                      amount: (
                        <Format.Currency>
                          <InlineTextLock enabled={locked}>
                            {Format.number(absRound(paymentSavings))}
                          </InlineTextLock>
                        </Format.Currency>
                      )
                    }}
                  />
                </Text>
              )
            }}
          />
        </span>
      </li>
    </ul>
  </div>
)

export default RefiPoint
